import React from 'react';
import useAuth from 'core/hooks/useAuth';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { acceptedTreatmentPartner } from 'stores/treatments/treatmentActions';
import { setVisualized } from 'stores/notifications/notificationActions';
import { Button } from 'antd';
import NotificationDate from './NotificationDate';

const NotificationTreatmentItem = ({ item, fetch }) => {
  const dispatch = useDispatch();
  const { refresh, refreshToken } = useAuth();
  const history = useHistory();
  const { notification, isActive, creationTime } = item;

  const { treatmentPartnerAcceptingId } = useSelector(
    (c) => c.resources?.treatments ?? {}
  );

  const handleSuccess = ({ data }) => {
    const { pathname } = window.location;

    fetch();
    dispatch(setVisualized(item.id));
    refresh({ refreshToken, type: 'professional' });

    if (
      pathname.startsWith('/app/medical-care/patients/') &&
      pathname.endsWith('/history')
    ) {
      history.replace(`/app/medical-care/patients/${data.result?.id}/history`);
      window.location.reload();
      return;
    }

    history.push(`/app/medical-care/patients/${data.result?.id}/history`);
  };

  const handleAccepted = (id) => {
    dispatch(acceptedTreatmentPartner(id, handleSuccess));
  };

  const parameters = JSON.parse(notification.parameters ?? '{}');
  const { patientName, profissionalName, treatmentPartnerId } = parameters;

  return (
    <div>
      <div className="gx-fs-md">
        <span>
          Você foi convidado para participar do tratamento do(a) paciente
          <span className="gx-font-weight-bold">{` ${patientName} `}</span>
          iniciado por
          <span className="gx-font-weight-bold">{` ${profissionalName}.`}</span>
        </span>
      </div>
      <NotificationDate date={creationTime} />

      {isActive && (
        <Button
          className="gx-mt-2"
          size="small"
          onClick={() => handleAccepted(treatmentPartnerId)}
          loading={treatmentPartnerId === treatmentPartnerAcceptingId}
        >
          Aceitar
        </Button>
      )}
    </div>
  );
};

export default NotificationTreatmentItem;
